import { render } from "./P015.vue?vue&type=template&id=239435e0&scoped=true"
import script from "./P015.vue?vue&type=script&lang=js"
export * from "./P015.vue?vue&type=script&lang=js"

import "./P015.vue?vue&type=style&index=0&id=239435e0&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239435e0"]])

export default __exports__